import { useState } from "react";
import { Btn, Modal, Field, Inp, Sel, Txta, FormRow, Stage, ExpandTable, Selo, Detalhe, Chips } from "../components/primitives";

function HookModal({ initial, onClose, onSave }) {
  const [f, setF] = useState(initial || {
    hook: "", estrategia: "", emocao: "", nicho: "", plataforma: "Meta", aplicavel: true, fonte: "", observacao: "",
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);
  async function save() { setSaving(true); await onSave(f); setSaving(false); }

  return (
    <Modal title={initial ? "Editar hook" : "Novo hook"} onClose={onClose} width={520}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Field label="Hook (texto)">
          <Txta rows={3} value={f.hook} onChange={(e) => up("hook", e.target.value)} placeholder="O hook que prende a atenção..." />
        </Field>
        <Field label="Estratégia">
          <Inp value={f.estrategia || ""} onChange={(e) => up("estrategia", e.target.value)} placeholder="O que esse hook faz..." />
        </Field>
        <FormRow>
          <Field label="Emoção" half><Inp value={f.emocao || ""} onChange={(e) => up("emocao", e.target.value)} placeholder="Medo, curiosidade, etc." /></Field>
          <Field label="Nicho" half><Inp value={f.nicho || ""} onChange={(e) => up("nicho", e.target.value)} placeholder="Médico, E-commerce..." /></Field>
        </FormRow>
        <FormRow>
          <Field label="Plataforma" half>
            <Sel value={f.plataforma || "Meta"} onChange={(e) => up("plataforma", e.target.value)}>
              {["Meta","Google","TikTok","Todos"].map((p) => <option key={p}>{p}</option>)}
            </Sel>
          </Field>
          <Field label="Fonte" half><Inp value={f.fonte || ""} onChange={(e) => up("fonte", e.target.value)} /></Field>
        </FormRow>
        <Field label="Observação"><Txta rows={2} value={f.observacao || ""} onChange={(e) => up("observacao", e.target.value)} /></Field>
        <Btn variant="accent" full onClick={save} disabled={saving}>{saving ? "Salvando..." : "Salvar"}</Btn>
      </div>
    </Modal>
  );
}

export function HooksView({ hooks, onNew, onUpdate }) {
  const [search,   setSearch]   = useState("");
  const [nicho,    setNicho]    = useState("Todos");
  const [plat,     setPlat]     = useState("Todos");
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [copied,   setCopied]   = useState(null);

  const nichos = ["Todos", ...new Set(hooks.map((h) => h.nicho).filter(Boolean))];
  const plats  = ["Todos", ...new Set(hooks.map((h) => h.plataforma).filter(Boolean))];

  const visible = hooks.filter((h) => {
    const q = search.toLowerCase();
    return (
      (nicho === "Todos" || h.nicho === nicho) &&
      (plat  === "Todos" || h.plataforma === plat) &&
      (!q || h.hook?.toLowerCase().includes(q) || h.estrategia?.toLowerCase().includes(q) || h.emocao?.toLowerCase().includes(q))
    );
  });

  function copy(text, id) {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 1800);
  }

  return (
    <div className="view">
      <Stage
        path="hooks"
        title="Biblioteca de"
        hl="hooks"
        lead={<>{hooks.length} hooks cadastrados</>}
        actions={<Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Novo hook</Btn>}
      />

      <div style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap", alignItems: "center" }}>
        <Inp value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar hooks..." style={{ maxWidth: 280 }} />
        <Sel value={nicho} onChange={(e) => setNicho(e.target.value)} style={{ width: "auto" }}>
          {nichos.map((n) => <option key={n}>{n}</option>)}
        </Sel>
        <Chips label="Plataforma" items={plats.map((p) => ({ id: p, label: p }))} active={plat} onChange={setPlat} />
        <span className="eyebrow" style={{ marginLeft: "auto" }}>{visible.length} resultado(s)</span>
      </div>

      <ExpandTable
        rows={visible}
        minWidth={600}
        empty="Nenhum hook encontrado."
        columns={[
          { key: "hook", label: "Hook", render: (h) => (
            <span className="name" style={{ display: "block", maxWidth: 520, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{h.hook}</span>
          ) },
          { key: "nicho", label: "Nicho", render: (h) => h.nicho || <span className="sub">—</span> },
          { key: "plat", label: "Plataforma", render: (h) => h.aplicavel === false
            ? <Selo tone="bad" dot={false}>Não aplicável</Selo>
            : (h.plataforma || <span className="sub">—</span>) },
          { key: "copiar", label: "", align: "right", render: (h) => (
            <span onClick={(e) => e.stopPropagation()}>
              <Btn sm variant={copied === h.id ? "success" : "ghost"} onClick={() => copy(h.hook, h.id)}>
                {copied === h.id ? "✓ Copiado" : "Copiar"}
              </Btn>
            </span>
          ) },
        ]}
        detail={(h) => (
          <div className="detail-grid">
            <Detalhe label="Hook" pre>{h.hook}</Detalhe>
            <Detalhe label="Estratégia">{h.estrategia}</Detalhe>
            <Detalhe label="Emoção">{h.emocao}</Detalhe>
            <Detalhe label="Fonte">{h.fonte}</Detalhe>
            <Detalhe label="Observação" pre>{h.observacao}</Detalhe>
            <div className="detail-actions">
              <Btn sm variant="secondary" onClick={() => setSelected(h)}>Editar</Btn>
            </div>
          </div>
        )}
      />

      {showForm && (
        <HookModal onClose={() => setShowForm(false)} onSave={async (data) => { await onNew(data); setShowForm(false); }} />
      )}
      {selected && (
        <HookModal initial={selected} onClose={() => setSelected(null)}
          onSave={async (data) => { await onUpdate(selected.id, data); setSelected(null); }} />
      )}
    </div>
  );
}
